import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { UserGroupsEdit } from 'components/Settings/Components/UserGroups/components/userGroupsEdit';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const UserGroupsEditPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userGroupsEdit.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.userGroupsEdit.title} showBack={true} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <UserGroupsEdit />
            </MainContent>
        </PageContainer>
    );
};
